import { render, staticRenderFns } from "./producao_cientifica.vue?vue&type=template&id=8c466164&"
import script from "./producao_cientifica.vue?vue&type=script&lang=js&"
export * from "./producao_cientifica.vue?vue&type=script&lang=js&"
import style0 from "./producao_cientifica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports